import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import theme from '../../theme';

const Section = styled.section`
  background: #ffffff;
  padding: 0;
  position: relative;
  z-index: 2;
`;

const Inner = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 5%;
  transform: translateY(-32px);

  @media (max-width: ${theme.breakpoints.mobile}) {
    transform: translateY(-20px);
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  background: #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.04),
    0 6px 24px rgba(0, 0, 0, 0.06);

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Card = styled.div`
  background: #ffffff;
  padding: 2rem 1.5rem;
  text-align: center;
  transition: background 0.2s ease;

  &:hover {
    background: #fafbfc;
  }
`;

const Number = styled.div`
  font-size: 2rem;
  font-weight: 800;
  color: ${theme.colors.secondary};
  letter-spacing: -0.5px;
  line-height: 1.1;
  margin-bottom: 0.4rem;

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1.6rem;
  }
`;

const Label = styled.div`
  font-size: 0.82rem;
  color: #64748b;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: 0.1px;
`;

const metrics = [
  { numberKey: 'trustMetrics.activeUsage.number', labelKey: 'trustMetrics.activeUsage.label' },
  { numberKey: 'trustMetrics.mobileRate.number', labelKey: 'trustMetrics.mobileRate.label' },
  { numberKey: 'trustMetrics.avgDealers.number', labelKey: 'trustMetrics.avgDealers.label' },
  { numberKey: 'trustMetrics.erp.number', labelKey: 'trustMetrics.erp.label' },
];

const TrustMetrics = () => {
  const { t } = useTranslation();

  return (
    <Section>
      <Inner>
        <Grid>
          {metrics.map((m, i) => (
            <Card key={i}>
              <Number>{t(m.numberKey)}</Number>
              <Label>{t(m.labelKey)}</Label>
            </Card>
          ))}
        </Grid>
      </Inner>
    </Section>
  );
};

export default TrustMetrics;
